export enum locationIcons {
    ok = 'assets/icon/location-ok.png',
    offline = 'assets/icon/location-offline.png',
    caution = 'assets/icon/location-caution.png',
    warning = 'assets/icon/location-warning.png',
    locon = 'assets/icon/location.png'
}
